import { get } from '../utils/http';
import { AssignTypes } from './types/coopTask';

/**
 * 获取坐席是否在职(接收离职协作坐席列表)
 * @param params 
 */
export function checkAgentStatus(params: AssignTypes) {
  return get('/api/lossAss/coopTask/agent', params);
}